import { getRandomUUID } from './common-util';
import { analyticsConfig } from './constant';
import { getSessionId, SESSION_ID_KEYS } from './session-utils';
import logger from './logger';
import { isMobile } from './device-utils';

/* global mixpanel */


const initAnalyticsTracker = () => {
    let initialized = false;
    let getAnalyticsData = (_source, _event, _eventData) => {
        logger.log({ source: _source, event: _event, eventData: _eventData });
        return {};
    };

    const sessionIds = { [SESSION_ID_KEYS.metricsTabId]: '' };
    // const utmMeta = {
    //     events: ['USER_FETCHED', 'USER_REGISTERED', 'PAGE_VIEW', 'CREATE_VIDEO_BUTTON_CLICKED', 'PAGE_LOADED', 'LOGIN_BUTTON_CLICKED', 'SIGNUP_BUTTON_CLICKED', 'USER_DROPOFF', 'CONTINUE_GOOGLE_SUCCESS', 'CONTINUE_GOOGLE_FAILED', 'SIGNUP_EMAIL_OTP_SUCCESS', 'ONBOARDING_SUCCESS', 'ONBOARDING_FAIL'],
    //     utmTags: {
    //         utmSource: '',
    //         utmMedium: '',
    //         utmCampaign: '',
    //         utmId: '',
    //         utmContent: '',
    //         utmTerm: '',
    //     },
    // };

   

    const initializeAnalytics = (init, analyticsGetter, counter = 0) => {
        if (analyticsGetter) {
            getAnalyticsData = analyticsGetter;
        }
        if (init) {
            // setUtmTags();
            // initialise mixpanel;
            try {
                const trackingID = analyticsConfig.mixPanel.token;
                mixpanel.init(trackingID, analyticsConfig.mixPanel.initConfig);
                mixpanel.identify();
                initialized = true;
                mixpanel?.start_session_recording?.();

                // set tab Id, unique to each tab
                sessionIds.metricsTabId = sessionStorage.getItem(SESSION_ID_KEYS.metricsTabId) || `tab_${getRandomUUID()}`;
                sessionStorage.setItem(SESSION_ID_KEYS.metricsTabId, sessionIds.metricsTabId);
            } catch (e) {
                logger.error('Error in initializing analytics', e);
                if(counter < 10) initializeAnalytics(init, analyticsGetter, counter + 1);
            }
        }
    };

    const identifyUser = (user) => {
        // set user properties in mixpanel
        mixpanel.people.set('username', user.username);
        mixpanel.people.set('name', user.username);
        mixpanel.people.set('email', user.email);
        mixpanel.people.set('persona', user.personas?.[0] || user.profile.questionnaireResponse?.persona);
        mixpanel.people.set('department', user.profile?.questionnaireResponse?.department);
        mixpanel.people.set('company', user.profile?.questionnaireResponse?.company);
        mixpanel.people.set('isMarketingConsent', user.profile?.isMarketingConsent);
        mixpanel.people.set('onboardedProduct', user.onboardedProduct);
        mixpanel.people.set('onboardedOn', user.onboardedOn);
        mixpanel.people.set('tenantRoles', user.tenantRoles);
    };

    const sendMixpanelEvent = (data) => {
        if (initialized && data) {
            try {
                // logger.log(data.event, 'Sending EVENT', initialized, data);
                const { event, ...restEventData } = data;
                mixpanel.track(event, { ...restEventData });
            }
            catch (e) {
                logger.error('Error in sending analytics event', e);
            }
        }
    };

    const sendAnalyticsEvent = (source, event, eventData) => {
        // TODO: dynamically get analytics data
        let analyticsData = getAnalyticsData(source, event, eventData);
        // console.log(`Analytics`, analyticsData, source, event, eventData);

        const slug = window.localStorage.getItem('slug');
        if (slug) {
            analyticsData = { ...analyticsData, slug };
        }

        let userId = window.localStorage.getItem('userId');
        if (!userId) {
            userId = getRandomUUID();
            window.localStorage.setItem('userId', userId);
        }
        analyticsData = { ...analyticsData, userId };

        // if (utmMeta.events.includes(event)) {
        //     analyticsData = { ...analyticsData, ...utmMeta.utmTags };
        // }
        sendMixpanelEvent({
            sessionId: getSessionId(),
            tabId: sessionIds.metricsTabId,
            eventId: getRandomUUID(), // this is eventAvataarId, unique to each event
            isMobile: isMobile(),
            ...analyticsData,
        });
    };

    return {
        sendAnalyticsEvent,
        identifyUser,
        initializeAnalytics,
    };
};

const AnalyticsTracker = initAnalyticsTracker();
export {
    AnalyticsTracker,
};
